import React from 'react'
import { IconProps } from './types'

export const IconOutlineCurrencyDollar = ({
	size = '1em',
	...props
}: IconProps) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={size}
			height={size}
			fill="none"
			viewBox="0 0 24 24"
			focusable="false"
			{...props}
		>
			<path
				fill="currentColor"
				fillRule="evenodd"
				d="M12 4a8 8 0 1 0 0 16 8 8 0 0 0 0-16ZM2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Zm10-6a1 1 0 0 1 1 1v.092c.94.177 1.791.604 2.354 1.253a1 1 0 0 1-1.51 1.31c-.163-.187-.453-.377-.844-.504v1.941a4.535 4.535 0 0 1 1.676.662C15.398 12.234 16 13.009 16 14c0 .99-.602 1.765-1.324 2.246-.48.32-1.054.545-1.676.662V17a1 1 0 1 1-2 0v-.092c-.94-.177-1.791-.604-2.354-1.253a1 1 0 0 1 1.51-1.31c.163.187.453.377.844.504v-1.941a4.535 4.535 0 0 1-1.676-.662C8.602 11.766 8 10.991 8 10c0-.99.602-1.765 1.324-2.246A4.535 4.535 0 0 1 11 7.092V7a1 1 0 0 1 1-1Zm-1 3.151c-.22.071-.412.164-.567.267C10.07 9.66 10 9.886 10 10c0 .114.07.34.433.582.155.103.346.196.567.267V9.151Zm2 4v1.698c.22-.071.412-.164.567-.267.364-.243.433-.468.433-.582 0-.114-.07-.34-.433-.582A2.305 2.305 0 0 0 13 13.15Z"
				clipRule="evenodd"
			/>
		</svg>
	)
}
